import { render, staticRenderFns } from "./scan.vue?vue&type=template&id=63ea8dfc&scoped=true"
import script from "./scan.vue?vue&type=script&lang=js"
export * from "./scan.vue?vue&type=script&lang=js"
import style0 from "./scan.vue?vue&type=style&index=0&id=63ea8dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ea8dfc",
  null
  
)

export default component.exports